import script from "./AdminNoticeCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminNoticeCard.vue?vue&type=script&setup=true&lang=ts"

import "./AdminNoticeCard.vue?vue&type=style&index=0&id=374bc190&scoped=true&lang=css"

import exportComponent from "../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-374bc190"]])

export default __exports__